import PropTypes from 'prop-types';
import React from 'react';

import Carousel from '../Carousel';
import EventCard from '../EventCard';

const EventListCarousel = ({ events, source, lazy }) => (
  /**
   * Note: Inline styles to allow space for tooltip without
   * being cut off by overflow styles from within Slick slider
   */
  <div style={{ marginTop: '-20px' }}>
    {events.length > 0 && (
      <Carousel
        className="carousel-fullwidth-mobile-experiment"
        lazyLoad="progressive"
        accessibility
        slidesToScroll={3}
        slidesToShow={3}
        swipeToSlide
        settingsXS={{
          slidesToScroll: 1,
          slidesToShow: 1,
          arrows: false,
          swipe: true,
          variableWidth: true,
        }}
        settingsSM={{
          slidesToScroll: 1,
          slidesToShow: 2,
          arrows: true,
        }}
        settingsMD={{
          slidesToScroll: 2,
          slidesToShow: 2,
          arrows: true,
        }}
      >
        {events.map((event) => (
          <div key={event.id} style={{ height: '20rem', marginTop: '20px' }}>
            <EventCard {...event} source={source} lazy={lazy} />
          </div>
        ))}
      </Carousel>
    )}
  </div>
);

EventListCarousel.propTypes = {
  /**
   * Array of event data objects to render
   */
  events: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  /**
   * If the images should be lazy loaded or not.
   */
  lazy: PropTypes.bool,

  /**
   * The following properties didn't have a prop types set
   * and I'm just guessing what they should be to get passed
   * the linter.
   */
  loggedIn: PropTypes.bool,
  onDone: PropTypes.func,
  onSave: PropTypes.func,
  onUnsave: PropTypes.func,
  savedEvents: PropTypes.shape(),

  /**
   * String source of list location.
   */
  source: PropTypes.string,
};

EventListCarousel.defaultProps = {
  lazy: false,
  loggedIn: false,
  onDone: () => {},
  onSave: () => {},
  onUnsave: () => {},
  savedEvents: undefined,
  source: undefined,
};

export default EventListCarousel;
